import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/ButtonBase';
import moment, { isMoment } from 'moment';
import { connect } from "react-redux";

import ViewOptions from './ToggleGroup';
import FiltersBar from './FiltersBar';
import SameDaysMessage from "./sameDaysMessage";

import ListSuppliers from '../../components/List/Lodging/suppliers';
import SearchBar from '../../components/SearchBar/Lodging';
import Breadcrumb from '../../components/Breadcrumb';
import SpotlioIcon from '../../components/Icon';
import SearchingScreen from '../../components/Layout/SearchingScreen';
import NoResultsScreen from '../../components/Layout/NoResultsScreen';
import LoadingLodgingList from '../../components/Layout/LoadingLayouts/LodgingList';
import Sortings from '../../components/Sortings/ListMenu';
import Map from '../../components/Map';
import SEO from '../../components/Seo';
import Carousel from '../../components/Carousel';
import CellLodging from "../../components/Cell/Lodging";
import MobileMessage from "../../components/MobileMessage";
import SpecialDatesModal from "../../components/SpecialDatesModal";

import IntlMessage from '../../LocaleEngine';

import PushHistory from '../../utils/PushHistory';
import QueryStringRetriever from '../../utils/QueryStringRetriever';
import request from '../../utils/request';
import { getSortOrder, setSortOrder, getSystemSettings, getSessionId, getDestination, setLodgingFilters, getLodgingFilters } from '../../utils/SettingsRetriever';
import getDateFormat from "../../utils/DateFormatRetriever";
import { setForm } from "../../services/form";
import { GAPageView, GATiming } from '../../utils/ga';
import { slugify } from "../../utils/string";

import 'react-input-range/lib/css/index.css';
import './index.scss';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterPrice: {
        min: 0,
        max: 20
      },
      selectedFilterPrices: {
        min: 5,
        max: 10
      },
      displayMap: false,
      displayMapMobile: false,
      displayList: true,
      loading: true,
      suppliers: [],
      renderedSuppliers: [],
      visiblerooms: [],
      visibleoffers: [],
      sortOrder: this.props.configuration.config ? this.props.configuration.config.defaultSort : (getSortOrder() || 'A-Z'),
      errorMessage: false,
      width: '',
      search: this.props.configuration && this.props.configuration.config && this.props.configuration.config.searchModal && this.props.configuration.config.searchModal.autoShowMobile ? true : false,
      filter: false,
      sort: false,
      searchQuery: {},
      loadingSearch: false,
      make: false,
      // confirmSearch: false,
      resultCount: 0,
      open: null,
      currentStep: 1,
      enablesortings: true,
      searchingModes: {
        default: 1,
        searching: 1
      },
      rebuildFilters: true,
      specialDates: {},
      specialDatesModal: false
    }

    this.productSuperCategoryId = this.props.configuration.productSupercategoryId;

    if(this.props.configuration.config.searchingModes){
      if(this.props.configuration.config.searchingModes.default) this.state.searchingModes.default = this.props.configuration.config.searchingModes.default;
      if(this.props.configuration.config.searchingModes.searching) this.state.searchingModes.searching = this.props.configuration.config.searchingModes.searching;
    }
  }

  componentDidMount() {
    setLodgingFilters(false);
    this.getSuppliers();
    this.pageView();
    window.addEventListener('scroll', this.listenToScroll)
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.listenToScroll)
    this.updateSectionStyles(true);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevMap = prevState.displayMapMobile
    const currentMap = this.state.displayMapMobile

    if(!prevMap && currentMap) this.updateSectionStyles();
    else if(prevMap && !currentMap) this.updateSectionStyles(true);
  }

  updateSectionStyles = (remove = false) => {
    const section = document.getElementsByTagName("section")[0]
    const root = document.getElementById("root")

    if(!remove) {
      section.style.overflowY = "hidden";
      section.style.position = "fixed";
      section.style.height = "100%";
      root.style.overflowY = "hidden";
      root.style.position = "fixed";
      root.style.height = "100%";
    } else {
      section.style.overflowY = null;
      section.style.position = null;
      section.style.height = null;
      root.style.overflowY = null;
      root.style.position = null;
      root.style.height = null;
    }
  }

  listenToScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    if (winScroll >= 200 && !this.state.showMapToggler && window.innerWidth <= 991){
      this.setState({ showMapToggler: true })
    } else if (winScroll < 200 && this.state.showMapToggler){
      this.setState({ showMapToggler: false})
    }
  }

  handleBuildFilters = () => {
    this.setState({rebuildFilters: false})
  }

  getSuppliers = () => {
    let extendedQuery = this.state.searchingModes.default === 1 ? 1 : 0;
    let url = getSystemSettings().api + '/getSuppliers?id=' + getSystemSettings().id + '&extended='+extendedQuery+'&productSuperCategoryId=' + this.productSuperCategoryId
    if (getDestination()){
      url += '&destination=' + getDestination().join(",")
    }
    if (this.props.configuration && this.props.configuration.code){
      url += '&identifier=' + this.props.configuration.code;
    }
    request({
      url: url,
      method: 'GET'
    }).then((result) => {
      if (result.status === 200) {
        let mlos = result.data.mlos;
        result = result.data.result;
        let cities = [];
        let selectedCities = {};
        let query = QueryStringRetriever();
        let search = this.state.searchQuery;
        let state = this.state;
        state.mlos = mlos;

        if (result.length === 0 || (result.length === 1 && result[0] === null)) {
          state = { ...state, errorMessage: 'no-results', loading: false, currentStep: 1 };
          this.setState(state);
          return null;
        }

        result.forEach((val, index) => {
          if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.loadMore && this.props.configuration.config.loadMore.enabled && index <= this.props.configuration.config.loadMore.amount){
            state.loadMore = this.props.configuration.config.loadMore.amount
            val.visible = true
          }
          if(val && val.Supplier){
            if (cities.indexOf(val.Supplier.City) < 0) {
              cities.push(val.Supplier.City);
              selectedCities[val.Supplier.City] = false;
            }
          }
        });

        if(this.state.searchingModes.default === 1){
          state.loading = false;
        }

        state = {...state, suppliers: result, renderedSuppliers: result, resultCount: result.length};
        search = this.props.form.lodging;
        if (search.nights && !search.departureDate){
          search.departureDate = moment.utc(search.arrivalDate).clone().add(search.nights, 'days').format("YYYY-MM-DD")
        }

        if (query){
          Object.keys(query).forEach(key => {
            if ((key === "arrivalDate" || key === "arrivaldate" || key === "arrival" || key === "search_date") && query[key]) search.arrivalDate = moment.utc(query[key]).format("YYYY-MM-DD");
            if ((key === "departureDate" || key === "departure" || key === "departuredate") && query[key]) {
              search.departureDate = moment.utc(query[key]);
              search.nights = moment.duration(search.departureDate.diff(search.arrivalDate)).asDays();
              search.departureDate = search.departureDate.format("YYYY-MM-DD");
            }
            if ((key === "childs" || key === "childCount" || key === "childcount" || key === "children" || key === "search_childs") && query[key]) search.children = query[key];
            if ((key === "adults" || key === "adultCount" || key === "adultcount" || key === "search_adults") && query[key]) search.adults = query[key];
            if ((key === "nights" || key === "search_nights" || key === "search_night") && query[key]) {
              search.nights = query[key]
              search.departureDate = moment.utc(search.arrivalDate).clone().add(search.nights, 'days').format("YYYY-MM-DD")
            }
            if (key === "childrenAges"){
              if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.childrenAgesSelector){
                if (typeof query["childrenAges"] === "string" && query["childrenAges"].indexOf(",")){
                  search.childrenAges = query[key].split(",");
                  search.children = query[key].split(",").length;
                } else {
                    search.childrenAges = [query[key]];
                    search.children = 1;
                }
              }
          }
          })

          if ( moment.utc(search.arrivalDate).endOf('day').isBefore(moment.utc().endOf('day')) || search.arrivalDate === "Invalid date") { search.arrivalDate = moment.utc().add(2, 'days').format("YYYY-MM-DD"); }
          if ( moment.utc(search.departureDate).isSameOrBefore(moment.utc(search.arrivalDate)) || search.departureDate === "Invalid date") { search.departureDate = moment.utc(search.arrivalDate).clone().add(2, 'days').format("YYYY-MM-DD"); }

          state.searchQuery = search;
          state.loadingSearch = true;
          this.setState(state, () => {
            setForm({
              ...this.props.form,
              lodging: {
                ...search,
                manualSearch: true
              },
            }, true, moment.utc(search.arrivalDate))
            this.getSupplierListDetails();
          });
        } else {
          this.setState(state);
        }
      } else {
        this.setState({ ...this.state, errorMessage: 'request-failed', loading: false })
      }
    }).catch(err => {
      console.log(err);
      this.setState({ ...this.state, errorMessage: 'request-failed', loading: false });
    });

    window.addEventListener("resize", this.updateDimensions);
  }

  pageView() {
    GAPageView({
        globalSettings: getSystemSettings(),
        sectionSettings: this.props.configuration,
        sessionId: getSessionId()
    });
  }

  getSupplierListDetails = () => {
    let mlos = this.state.mlos;
    let { arrivalDate, nights } = this.state.searchQuery;
    if (mlos.find(item => item.day === arrivalDate && nights < item.minStay)){
      this.setState({ errorMessage: "mlos", loading: false, loadingSearch: false });
    } else {
      const initQuery = new Date().getTime();

      let requests = this.state.suppliers.map(element => {
          return this.getSupplier(element).catch(function(error){console.error(error)});
      });
  
      Promise.all(requests)
      .then(suppliers => {
        let resultCount = 0;
        let arraySuppliers = [];
        suppliers.forEach(supplier => {
          if (supplier !== undefined ){
            resultCount += supplier.Products_Lodging.length;
            arraySuppliers.push(supplier);
          }
        })
        if (resultCount === 0){
          resultCount = arraySuppliers.length;
        }
  
        this.setState({
          resultCount: resultCount, 
          suppliers: arraySuppliers.length > 0 ? arraySuppliers : this.state.suppliers, 
          loadingSearch: false, 
          make: true, 
          loading: false, 
          rebuildFilters: true, 
          renderedSuppliers: arraySuppliers 
        }, () => {
          if (arraySuppliers.length === 0){
            this.toggleSearch(true);
          }
        });
        
        if (!getLodgingFilters()){
          this.setSort(this.state.sortOrder, arraySuppliers, true);
        }
  
        GATiming({
          globalSettings: getSystemSettings(),
          sectionSettings: this.props.configuration,
          initial: initQuery,
          data: {
            arrivalDate: isMoment(this.state.searchQuery.arrivalDate) ? this.state.searchQuery.arrivalDate.format('YYYY-MM-DD') : this.state.searchQuery.arrivalDate,
            departureDate: isMoment(this.state.searchQuery.departureDate) ? this.state.searchQuery.departureDate.format('YYYY-MM-DD') : this.state.searchQuery.departureDate,
            adults: this.state.searchQuery.adults,
            children: this.state.searchQuery.children
          }
        });
      });
    }
  }

  searchHandler(form){
    let system = getSystemSettings();
    setLodgingFilters(false);
    if (system && system.app && system.app.alertMessageSpecialDates && system.app.alertMessageSpecialDates.enabled && system.app.alertMessageSpecialDates.list) {
      // then, we look through it's list
      let specialDates = system.app.alertMessageSpecialDates.list.find(specialDate => {
        // if the item has a valid title & message, we check the range of dates
        if (specialDate.title && specialDate.message && specialDate.ranges.find(dates => {
          let fromDate = moment.utc(dates.from).startOf("day");
          let toDate = moment.utc(dates.to).startOf("day");
          let searchDate = moment.utc(form.arrivalDate).startOf("day");
          let searchEndDate = moment.utc(form.departureDate).startOf("day")
          // if the date we searched is also between the range, then we have display the modal!
          if (searchDate.isSameOrAfter(fromDate) && searchDate.isSameOrBefore(toDate)) return true;
          if (searchEndDate.isSameOrAfter(fromDate) && searchEndDate.isSameOrBefore(toDate)) return true;
          // if not, return false
          return false;
        })){
          return true;
        } else {
          return false;
        }
      })
      if (specialDates){
        this.setState({
           specialDatesModal: true,
           specialDates, 
          //  loadingSearch: this.state.searchingModes.default === 2 ? false : true, 
          //  loading: this.state.errorMessage || this.state.searchingModes.default === 2 ? true : false, 
           searchQuery: form, 
           errorMessage: false, 
           open: null, 
           currentStep: 1 
        })
      } else {
        this.setState({ loadingSearch: this.state.searchingModes.default === 2 ? false : true, loading: this.state.errorMessage || this.state.searchingModes.default === 2 ? true : false, searchQuery: form, errorMessage: false, open: null, currentStep: 1 }, ()=>{
          this.getSupplierListDetails();
        })
      }
    }  else {
      this.setState({ loadingSearch: this.state.searchingModes.default === 2 ? false : true, loading: this.state.errorMessage || this.state.searchingModes.default === 2 ? true : false, searchQuery: form, errorMessage: false, open: null, currentStep: 1 }, ()=>{
        this.getSupplierListDetails();
      })
    }
  }

  getSupplier = (element) => {
    let id = element.SupplierId || element.Supplier.SupplierId;

    let data = {
      id: getSystemSettings().id,
      supplierId: id,
      arrivalDate: isMoment(this.state.searchQuery.arrivalDate) ? this.state.searchQuery.arrivalDate.format('YYYY-MM-DD') : this.state.searchQuery.arrivalDate,
      departureDate: isMoment(this.state.searchQuery.departureDate) ? this.state.searchQuery.departureDate.format('YYYY-MM-DD') : this.state.searchQuery.departureDate,
      adults: this.state.searchQuery.adults,
      children: this.state.searchQuery.children
    }

    if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.childrenAgesSelector && this.state.searchQuery.childrenAges && this.state.searchQuery.childrenAges){
      data.childrenAges = this.state.searchQuery.childrenAges.join(",")
    }

    return new Promise( (resolve, reject) => {
        request({
            url: getSystemSettings().api + '/lodging/supplier',
            method: 'POST',
            data
        })
        .then( (result) => {
            result = result.data.result;
            if (typeof result === 'string') {
                return true;
            }
            resolve(result);
        })
        .catch( (err) => {
            reject(err);
        });
    });
  }

  toggleSearch(value){
    this.setState({ ...this.state, search: value });
    /*
    if (this.state.search === true){
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100%";
      document.body.style.position = "fixed";
    } else {
      document.body.removeAttribute('style');
    }
    */
  }

  toggleFilter(value){
    this.setState({...this.state, filter: value});
    /*
    if (value === true){
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100%";
      document.body.style.position = "fixed";
    } else {
      document.body.removeAttribute('style');
    }
    */
  }

  toggleSort(value){
    this.setState({...this.state, sort: value});
  }

  toggleFullMap() {
    this.setState({ displayMapMobile: !this.state.displayMapMobile, enablesortings: !this.state.enablesortings }, () => {
      window.scrollTo(0, 0)
    });
  }

  setMap(value) {
    this.setState({ ...this.state, displayMap: value, displayList: !value })
  }

  setList(value) {
    if (value === true) {
      this.setState({ ...this.state, displayList: value, displayMap: false });
    }
  }

  compareFeatured(a, b) {
    if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.sortOptions){
      let option = this.props.configuration.config.sortOptions.find(option => option.name === "Featured")
      if (option && option.field){
        if (option.reverse) return b.Supplier[option.field] - a.Supplier[option.field];
        return a.Supplier[option.field] - b.Supplier[option.field];
      }
    }
    return a.Supplier.Position - b.Supplier.Position;
  }

  sortFunction(value, a, b) {
    let reverse = undefined;
    let field = undefined
    this.props.configuration.config.sortOptions.forEach( (option) => {
        if (option.name === value){
            reverse = option.reverse;
            field = option.field;
        }
    })

    if (QueryStringRetriever().featured){
      if (a.Supplier && a.Supplier.SupplierId === QueryStringRetriever().featured){
        return -1;
      }
      if (b.Supplier && b.Supplier.SupplierId === QueryStringRetriever().featured){
        return 1;
      }
    }

    if (field === "special"){
      a.diff = a.Supplier.OriginalFromPrice - a.Supplier.FromPrice
      b.diff = b.Supplier.OriginalFromPrice - b.Supplier.FromPrice

      if (a.diff < b.diff){
        return reverse ? -1 : 1
      }
      if (a.diff > b.diff){
        return reverse ? 1 : -1
      }
    }

    if (a.Supplier[field] < b.Supplier[field]){
      return reverse ? 1 : -1
    }
    if (a.Supplier[field] > b.Supplier[field]){
      return reverse ? -1 : 1
    }
    return 0;
  }

  resetFilters = () => {
    setLodgingFilters(false);
    this.setSort(this.state.sortOrder, this.state.suppliers);
  }

  setSort(value, suppliers = this.state.renderedSuppliers) {
    let state = this.state;
    if (value === "Featured"){
      suppliers.sort(this.compareFeatured.bind(this))
    } else {
      suppliers.sort(this.sortFunction.bind(this, value))
    }
    this.toggleSupplier(null);
    setSortOrder(value);
    let resultCount = 0;
    suppliers.forEach(supplier => {
      if (supplier && supplier.Products_Lodging ){
        resultCount += supplier.Products_Lodging.length;
      }
    })
    if (resultCount === 0){
      resultCount = suppliers.length;
    }

    state = {...state, renderedSuppliers: suppliers, sortOrder: value, resultCount: resultCount, open: null };
    this.setState(state, () => this.handleSoldOuts());
  }

  toggleRooms = (index) => {
    let visiblerooms = this.state.visiblerooms
    if (visiblerooms[index] === false || !visiblerooms[index]) {
      visiblerooms[index] = true
    } else {
      visiblerooms[index] = false
    }
    this.setState({ visiblerooms: visiblerooms })
  }

  toggleOffers = (offerindex) => {
    let visibleoffers = this.state.visibleoffers
    if (visibleoffers[offerindex] === false || !visibleoffers[offerindex]) {
      visibleoffers[offerindex] = true
    } else {
      visibleoffers[offerindex] = false
    }
    this.setState({ visibleoffers: visibleoffers })
  }

  updateDimensions = () => {
    this.setState({width: window.innerWidth});
  }

  handleChangeSuppliers = (suppliers) => {
    this.setSort(this.state.sortOrder, suppliers);
  }

  handleSoldOuts = () => {
    let arraySuppliers = []
    let state = this.state;

    state.renderedSuppliers.forEach(supplier => {
      if ( (supplier.Products_Lodging && supplier.Products_Lodging.length !== 0) || !this.state.make){
        arraySuppliers.push(supplier);
      }
    });
    arraySuppliers.forEach((supplier, index) => {
      if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.loadMore && this.props.configuration.config.loadMore.enabled && index <= this.state.loadMore){
        supplier.visible = true
      } else {
        supplier.visible = false
      }
      if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.markAsSpecial && supplier.Supplier && supplier.Supplier.FromPrice !== supplier.Supplier.OriginalFromPrice){
        supplier.Supplier.special = true;
      }
    })

    state = {...state, renderedSuppliers: arraySuppliers, errorMessage: false};

    if(arraySuppliers.length === 0){
      state.loading = false;
      state.errorMessage = 'no-results';
      state.currentStep = 1
    }
    this.setState({ ...state }, () => {
      if (QueryStringRetriever().featured && this.props.configuration && this.props.configuration.config && this.props.configuration.config.toggleFeaturedUnits){
        let qsSupplier = QueryStringRetriever().featured;
        let supplierOnArray = this.state.renderedSuppliers.find(supp => supp.Supplier.SupplierId === qsSupplier)
        if (supplierOnArray && window.innerWidth > 991){
          this.toggleSupplier(this.state.renderedSuppliers.indexOf(supplierOnArray))
        }
      }
    });
  }

  handleGoToSupplier = (supplier) => {
    document.body.style.overflowY = "unset";
    document.body.style.height = "unset";
    document.body.style.position = "unset"
    document.body.removeAttribute('style');
    let linkToSupplierPage = '/supplier/' + slugify(supplier.SupplierName) + '/' + supplier.SupplierId;
    !this.state.make ?
    PushHistory(linkToSupplierPage)
    :
    PushHistory(linkToSupplierPage + '/?arrivalDate=' + moment.utc(new Date(this.state.searchQuery.arrivalDate)).format(getDateFormat()) + '&departureDate=' + moment.utc(new Date(this.state.searchQuery.departureDate)).format(getDateFormat()) + '&adults=' + this.state.searchQuery.adults + '&children=' + this.state.searchQuery.children);
  }

  toggleSupplier = (index) => {
    if (this.state.open !== null){
        this.setState({open: null, currentStep: 1})
    } else {
        this.setState({open: index, currentStep: 2})
    }
  }

  handleChangeBreadcrumbStep = (step) => {
    this.setState({
      ...this.state,
      currentStep: step
    });
  }

  handleRenderBreadcrumb = () => {
    let resultsKey = "Results";
    let propertyKey = "Property";
    let roomKey = "Room";
    let addItemsKey = "Add Items";
    let checkoutKey = "Checkout";

    if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.label_customization && this.props.configuration.config.label_customization.breadCrumb){
      if (this.props.configuration.config.label_customization.breadCrumb.room) roomKey = this.props.configuration.config.label_customization.breadCrumb.room;
    }
    const steps = [ resultsKey, propertyKey, roomKey, addItemsKey, checkoutKey ];
    return <Breadcrumb steps={steps} current={this.state.currentStep} withBottomMargin={true} withTopMargin={true} />
  }

  loadMore = () => {
    let loadMore = this.state.loadMore;
    let renderedSuppliers = this.state.renderedSuppliers;

    if (this.state.renderedSuppliers.length < (this.state.loadMore + this.props.configuration.config.loadMore.amount)) loadMore = this.state.renderedSuppliers.length
    else loadMore = this.state.loadMore + this.props.configuration.config.loadMore.amount
    for (let i = this.state.loadMore; i < loadMore; i++){
      renderedSuppliers[i].visible = true;
    }
    this.setState({ renderedSuppliers, loadMore });
  }

  getDestinations = () => {
    if (getDestination()){
      if (getDestination().length > 1){
        return (
          <div onClick={() => this.setState({ displayDestinations: !this.state.displayDestinations })} className="currentDestination">
            <strong >Multiple destinations</strong>
            {
              this.state.displayDestinations &&
                <div className="destinationsToolTip">
                  {
                    getSystemSettings().multiDestination.list.map(destination => {
                      if ( getDestination().find( dest => parseInt(dest) === parseInt(destination.id) ) ) {
                        return <div><strong key={destination.id}>{" " + destination.name + " "}</strong></div>
                      }
                      return null;
                    })
                  }
                </div>
            }
          </div>
        )
      } else {
        return (
          <div className="currentDestination">
            {
              getSystemSettings().multiDestination.list.map(destination => {
                if ( getDestination().find( dest => parseInt(dest) === parseInt(destination.id) ) ) {
                  return <strong key={destination.id}>{" " + destination.name + " "}</strong>
                }
                return null;
              })
            }
          </div>
        )
      }
    }
    return null;
  }

  getDestinationName = () => {
    let destinationName = '';
    if (getDestination()) {
        if (getDestination().length > 1) {
          destinationName = "Multiple destinations";
          return destinationName;
        }
        getSystemSettings().multiDestination && getSystemSettings().multiDestination && getSystemSettings().multiDestination.list.forEach(destination => {
            if ( getDestination().find( dest => parseInt(dest) === parseInt(destination.id) ) ) {
                destinationName = destination.name;
            }
        })
    }
    return destinationName;
  }

  closeMapMobile = () => {
    this.setState({ displayMapMobile: false }, () => {
      document.body.removeAttribute('style');
    });
  }

  getResultsMessage = () => {
    if (this.props.configuration && this.props.configuration.config && this.props.configuration.config.resultMessage){
      if (this.props.configuration.config.resultMessage.enabled === false){
        return null;
      }
      if (this.props.configuration.config.resultMessage.enabled ){
        if (this.props.configuration.config.resultMessage.message && this.props.configuration.config.resultMessage.message.length > 0){
          return (
            this.props.configuration.config.resultMessage.message
            .replace(
              "[COUNTER]",
              this.props.configuration.config.resultMessage.counter === "supplier"
              ? this.state.renderedSuppliers.length
              : this.state.resultCount
            )
          )
        } else {
          return (
            <React.Fragment>
              <IntlMessage id="lodging.titles.found" />{" "}
              <strong>
                {this.props.configuration.config.resultMessage.counter === "supplier"
                ? this.state.renderedSuppliers.length
                : this.state.resultCount}
              </strong>{" "}
              <IntlMessage id="lodging.titles.accommodation_results" />{" "}
            </React.Fragment>
          )
        }
      }
    }
    return (
      <React.Fragment>
        <IntlMessage id="lodging.titles.found" />{" "}
        <strong>{this.state.resultCount}</strong>{" "}
        <IntlMessage id="lodging.titles.accommodation_results" />{" "}
      </React.Fragment>
    )
  }

  closeSpecialDatesModal = () => {
    this.setState({ 
      specialDatesModal: false,
      loadingSearch: this.state.searchingModes.default === 2 ? false : true, 
      loading: this.state.errorMessage || this.state.searchingModes.default === 2 ? true : false, 
    }, () => {
      this.getSupplierListDetails();
    })
  }

  getContent = () => {
    const handleSetMap = this.setMap.bind(this);
    const handleSetList = this.setList.bind(this);
    const handleSetSort = this.setSort.bind(this);
    const handleChangeSuppliers = this.handleChangeSuppliers.bind(this);
    const systemSettings = getSystemSettings();
    const isNotTierLoading = systemSettings.app && systemSettings.app.animationMobile && systemSettings.app.animationMobile.type && systemSettings.app.animationMobile.type !== 'tier';

    if (this.state.loading) {
      if(window.innerWidth <= 991 && !(isNotTierLoading))
        return (
          <>
            <SEO title="Home" />
            <LoadingLodgingList />
          </>
        )
      return (
          <React.Fragment>
              <SEO title="Home" />
              { this.handleRenderBreadcrumb() }
              <SearchingScreen message={this.props.configuration.config.searchingMessage} mode="loading" section="lodging" />
          </React.Fragment>
      )
    }
    if (this.state.errorMessage) {
        return (
            <React.Fragment>
                <MobileMessage
                  toggleButton={this.toggleSearch.bind(this)}
                  currentStep={[this.getDestinationName(), this.props.configuration.mobile_title]}
                  arrivalDate={this.state.searchQuery.arrivalDate}
                  departureDate={this.state.searchQuery.departureDate}
                  guests={this.state.searchQuery.adults + this.state.searchQuery.children}
                  mode={"lodging"}
                />                
                { this.handleRenderBreadcrumb() }
                <NoResultsScreen hasFilters={getLodgingFilters()} mlos={this.state.errorMessage === "mlos" && ( this.props.configuration.config.mlos || "No inventory available over selected dates. Thank you for your interest in Lodging. The minimum length of stay requirement has not been met over the selected dates")} resetFilters={this.resetFilters.bind(this)} message={this.props.configuration.config.noResultsMessage} section="lodging" code={this.props.configuration.code} sameDay={this.state.searchQuery.arrivalDate === this.state.searchQuery.departureDate}/>
            </React.Fragment>
        )
    }
    if (this.state.loadingSearch && this.props.configuration.config.loadingMode === 'full') {
      return (
        <React.Fragment>
          { this.handleRenderBreadcrumb() }
          <SearchingScreen message={this.props.configuration.config.searchingMessage} />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        { this.handleRenderBreadcrumb() }
        {/* <div style={this.state.loadingSearch ? {display: "inherit"} : {display:"none"}} className={"loadingsearch"}>
          <div>We're searching your selection...</div>
        </div> */}
        <Grid container spacing={2} className="lodgingSection">
          <Grid item xs={3} className="sidebar">
            {/* small map on the sidebar */}
            {
              getSystemSettings().app.enableMap !== false && 
              <Map 
                suppliers={this.state.renderedSuppliers.length !== 0 || this.state.make ? this.state.renderedSuppliers : this.state.suppliers} 
                setMapValue={handleSetMap} 
                update={false} 
                height="200px"
                viewPortHeight={200}
                viewPortWidth={285} 
                width="100%" 
                displayFull={this.state.displayMap} 
                display={true} 
              />
            }
            <FiltersBar 
              handleBuildFilters={this.handleBuildFilters.bind(this)} 
              rebuildFilters={this.state.rebuildFilters} 
              config={this.props.configuration}
              make={this.state.make} 
              suppliers={this.state.suppliers} 
              onChange={handleChangeSuppliers} 
              sortOrder={this.state.sortOrder} 
              renderSoldOuts={false} 
            /> 
          </Grid>
          <Grid item xs={9} className="content">
            <div className="results">
              <div className="head">
                <div className="message">
                  {!this.state.loadingSearch
                    ? <div>
                      {this.getResultsMessage()}
                      {this.state.make
                      ? <span className="formDataResult">
                          for {moment.utc(this.state.searchQuery.arrivalDate).format(getDateFormat("display")) + ", " + this.state.searchQuery.nights + " Nights, " + this.state.searchQuery.adults + " Adults, " + (this.state.searchQuery.children === 0 ? "No children" : (this.state.searchQuery.children > 1 ? this.state.searchQuery.children + " children" : " child" ))}
                        </span>
                      : null }</div>
                    : null
                    }
                </div>
                <MobileMessage
                  toggleButton={this.toggleSearch.bind(this)}
                  currentStep={[this.getDestinationName(), this.props.configuration.mobile_title]}
                  arrivalDate={this.state.searchQuery.arrivalDate}
                  departureDate={this.state.searchQuery.departureDate}
                  guests={this.state.searchQuery.adults + this.state.searchQuery.children}
                  mode={"lodging"}
                />
                <div className="options">
                  {getSystemSettings().app.enableMap !== false && <ViewOptions displayList={this.state.displayList} setListValue={handleSetList} displayMap={this.state.displayMap} setMapValue={handleSetMap} />}
                </div>
                <div className="sorting">
                  <Sortings
                    sortOptions={this.props.configuration.config.sortOptions}
                    enableSortings={this.state.enablesortings}
                    config={this.props.configuration.config.sortOptions}
                    currentSort={this.state.sortOrder}
                    setSort={handleSetSort}
                  />
                </div>
              </div>
              {/* mobile map displayed at the top of the screen */}
              {getSystemSettings().app.enableMap !== false && 
                <div onClick={()=>this.toggleFullMap()} className={"mobilemap"}>
                    <Map 
                      className={"mobilemap"} 
                      update={false} 
                      suppliers={this.state.renderedSuppliers.length !== 0 || this.state.make ? this.state.renderedSuppliers : this.state.suppliers} 
                      height="160px"
                      viewPortHeight={160}
                      viewPortWidth={360} 
                      width={this.state.width !== "" ? this.state.width : window.innerWidth}
                      display={true} 
                    />
                </div>
              }
              <div className="mobileSectionTitle">
                <div>Select a Lodging Property <span className="mobileSectionTitleTotal">({this.state.resultCount})</span></div>
                <div onClick={() => this.toggleFilter(true)} className="mobileFilterArea">
                  <SpotlioIcon icon="filter" />
                </div>
              </div>
              <Divider />
              <Grid style={this.state.displayList ? { display: "flex" } : { display: "none" }} container spacing={0} className="list">
                { !this.state.loading &&
                    <ListSuppliers
                      section={this.props.section}
                      sectionConfiguration={this.props.configuration.config}
                      currentStep={this.state.currentStep}
                      updateStep={(step) => this.handleChangeBreadcrumbStep(step)}
                      open={this.state.open}
                      toggleSupplier={this.toggleSupplier.bind(this)}
                      loadingSearch={this.state.loadingSearch}
                      make={this.state.make}
                      list={this.state.renderedSuppliers}
                    />
                }
                {
                  this.props.configuration && this.props.configuration.config && this.props.configuration.config.loadMore && this.props.configuration.config.loadMore.enabled && this.state.loadMore < this.state.renderedSuppliers.length ?
                  <Button onClick={()=>this.loadMore()} className="loadMore">
                    Load more (+{this.state.renderedSuppliers.length - this.state.loadMore < this.props.configuration.config.loadMore.amount ?
                    this.state.renderedSuppliers.length - this.state.loadMore : this.props.configuration.config.loadMore.amount})
                  </Button>
                  : null
                }
              </Grid>
              <div onClick={()=>this.toggleFullMap()} className={`toast ${this.state.showMapToggler ? 'visible' : 'hide'}`}>
                <SpotlioIcon icon="feather-map-pin" />
                Map view
              </div>
            </div>
            {/* big map displayed in desktop, when is the selected option, instead of the supplier list */}
            {
              getSystemSettings().app.enableMap !== false && 
              <Map 
                viewPortHeight={575}
                viewPortWidth={800}
                handleGoToSupplier={this.handleGoToSupplier.bind(this)} 
                update={true} 
                suppliers={this.state.renderedSuppliers.length !== 0 || this.state.make ? this.state.renderedSuppliers : this.state.suppliers} 
                height="67vh" 
                width="100%" 
                display={this.state.displayMap} 
              />
            }
            { getSystemSettings().app.enableMap !== false && 
              <div style={this.state.displayMapMobile ? { display: "inherit" } : { display: "none" }} className="fullmobilemap">
                  <Map 
                    mode={"fullMobileMap"}
                    handleGoToSupplier={this.handleGoToSupplier.bind(this)} 
                    className={"mobilemap"} 
                    update={true} 
                    suppliers={this.state.renderedSuppliers.length !== 0 || this.state.make ? this.state.renderedSuppliers : this.state.suppliers} 
                    height="100%" 
                    width="100%"
                    viewPortWidth={window.innerWidth}
                    viewPortHeight={window.innerHeight - 110} 
                    display={true} 
                  />
                  <Carousel
                    className={"rooms"}
                    options={{
                      centerSlidePercentage: this.state.renderedSuppliers.length > 1 ? 85 : 100,
                      showArrows: false,
                      showThumbs: false
                    }}
                  >
                    {
                      this.state.renderedSuppliers.map((element, index) => {
                        return <CellLodging 
                                mode={"map"}
                                sectionConfiguration={this.props.configuration.config} 
                                currentStep={this.state.currentStep} 
                                make={this.state.make}
                                key={index} 
                                index={index} 
                                element={element} 
                          />
                      })
                    }
                  </Carousel>
                  <div onClick={()=>this.toggleFullMap()} className="toast">
                    <SpotlioIcon icon="feather-list" />
                    List view
                  </div>
              </div>
            }
            {
              <SameDaysMessage 
                form={this.state.searchQuery} 
                config={this.props.configuration.config} 
              />
            }
          </Grid>
          <SpecialDatesModal
              closeModal={this.closeSpecialDatesModal.bind(this)}
              open={this.state.specialDatesModal}
              specialDates={this.state.specialDates}
          />
        </Grid>
        
      </React.Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
        <SEO title="Home" />
        <SearchBar
          subtitle={this.props.configuration.plansubtitle}
          resetFilters={this.resetFilters.bind(this)}
          section={this.props.section}
          closeMapMobile={this.closeMapMobile}
          subplan={this.props.configuration.subplan} 
          resultCount={this.state.resultCount} 
          make={this.state.make} 
          enableSortings={this.state.enablesortings} 
          config={this.props.configuration} 
          loading={this.state.loadingSearch} 
          searchQuery={this.state.searchQuery} 
          toggleFilter={this.toggleFilter.bind(this)} 
          searchHandler={this.searchHandler.bind(this)} 
          toggleSearch={this.toggleSearch.bind(this)} 
          search={this.state.search} 
          filter={this.state.filter} 
          suppliers={this.state.suppliers} 
          handleChangeSuppliers={this.handleChangeSuppliers.bind(this)} 
          handleSetSort={this.setSort.bind(this)} 
          sortOrder={this.state.sortOrder}
          hideSearchButton
        />
        {
          this.getContent()
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return { form: state.form.form }
}

export default connect(mapStateToProps)(Home)
